import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v1/';

class SubProductCategory {
  index() {
    return Axios.get(API_URL + 'subcategory-list');
  }

  show(subcategory) {
    return Axios.get(API_URL + `subcategory/${subcategory}`);
  }
}

export default new SubProductCategory();



// WEBPACK FOOTER //
// ./src/api/subproductcategory.js